import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import FormattedCurrencyContainer from '../../../../../../components/formatted-currency/container';
import messages from '../../messages';
import style from './preview-modal.module.less';
import { RateStatusIndicatorPlaceholder } from './rate-status-indicator-placeholder';

export const RateRowPlaceholder = ({ option }) => (
  <div className={classnames(style.rate, style.disabled)}>
    <div className={style['rate-info-block']}>
      <div className={style['radio-button-wrapper']}>
        <RadioCheckListItem />
      </div>
      <div className={style['rate-info']}>
        <div className={style['rate-name']}>{option.name}</div>
        <div className={style['rate-description']}>{option.description}</div>
      </div>
    </div>
    <div className={style['delivery-estimate-info']}>
      <div className={style['rate-delivery-time']}>
        <FormattedMessage {...messages.numberOfDays} />
      </div>
      <div className={style['rate-description']}>
        <FormattedMessage {...messages.estimatedTransitTime} />
      </div>
    </div>
    <RateStatusIndicatorPlaceholder isActive={option.isActive} />
    <div className={style['rate-price']}>
      <FormattedCurrencyContainer value={0} />
    </div>
  </div>
);

RateRowPlaceholder.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    isActive: PropTypes.bool,
  }).isRequired,
};
